import React from 'react'

import s from './styles.module.scss'

import { Button, BUTTON_COLOR } from '../../../atoms'

interface IHouseSearchTabletMobileFooterProps {
  showFilterSelector: boolean
  setShowFilterSelector: (show: boolean) => void
  clearAllFilters: () => void
}

export const HouseSearchTabletMobileFooter = ({
  showFilterSelector,
  setShowFilterSelector,
  clearAllFilters,
}: IHouseSearchTabletMobileFooterProps) => {
  return (
    <>
      {!showFilterSelector && (
        <div className={s.footerContainer}>
          <div className={s.footerContent}>
            <button
              onClick={() => {
                setShowFilterSelector(!showFilterSelector)
                clearAllFilters()
              }}
              className={s.clearButton}
            >
              Effacer les filtres
            </button>
            <Button
              color={BUTTON_COLOR.PRIMARY}
              onClick={() => setShowFilterSelector(!showFilterSelector)}
              contentClassName={s.button}
            >
              Voir les résultats
            </Button>
          </div>
        </div>
      )}
    </>
  )
}
